import type { SubPedido } from '../db/tipos'

// ▶ Pedido dela 14/10: com o pedido ja enviado, acrescentar produto de OUTRA
// tabela (ou de outra fornecedora) cria um sub-pedido NOVO, em rascunho, no mesmo
// pedido -- com o preco da tabela dele e o PDF dele. O sub-pedido ja enviado nao
// muda. Cada fornecedora e tabela segue com o seu documento (modelo de sempre).

// A tela de acrescentar so mostra o que ainda e rascunho: o que ja foi enviado
// fica protegido (sem caixinha de quantidade, sem remover).
export function subPedidosDoAcrescimo<T extends Pick<SubPedido, 'status'>>(subPedidos: T[]): T[] {
  return subPedidos.filter((s) => s.status === 'rascunho')
}

// Produto da MESMA fornecedora e MESMA tabela de um sub-pedido que ja saiu do
// rascunho: esse caso e o do "Ajustar itens" (pede motivo, entra no documento ja
// enviado). Cancelado tambem bloqueia: adicionarItem acharia esse sub-pedido e
// recusaria. Aqui nao se mistura -- a tela avisa e manda para la.
export function tabelaJaEnviada(
  subPedidos: Pick<SubPedido, 'representada_id' | 'tabela_preco_id' | 'status'>[],
  representadaId: string,
  tabelaId: string,
): boolean {
  return subPedidos.some(
    (s) => s.status !== 'rascunho'
      && s.representada_id === representadaId && s.tabela_preco_id === tabelaId,
  )
}
